import { headerLogoStartAlt } from './HeaderLogoStore.js';

export const updateHeaderLogoStartAlt = (value) => headerLogoStartAlt.update((oldValue) => value);
